<div class="container-fluid px-2 px-md-3 px-xl-1 py-3">
  <div class="d-flex flex-column gap-3">
    <section class="entity-config-top mb-1 rounded-4 overflow-hidden shadow-sm">
      <div class="entity-config-top-hero px-2 px-md-3 py-3">
        <div class="row g-2 align-items-start flex-nowrap">
          <div class="col">
            <h1 class="entity-page-title text-white fw-bold lh-sm mb-1">Template Management</h1>
            <p class="entity-page-subtitle text-white mb-0 subsystem-subtitle">
              Upload, browse, and manage your document templates and assignments across the platform.
            </p>
          </div>

          <div class="col-auto d-flex justify-content-end">
            <button
              type="button"
              class="btn btn-primary-dark text-xs d-inline-flex align-items-center rounded-3 px-3 py-2 shadow-sm me-2 align-self-end"
              @click="go_to_upload_template"
            >
              <i class="bi bi-upload me-2 text-white"></i>
              Upload New Template
            </button>

          </div>
        </div>
      </div>

      <div class="px-2 px-md-3 pb-3">
        <section class="row g-2 entity-config-top-metrics">
          <div class="col-12 col-md-6 mt-2">
            <article class="entity-metric-card h-100 rounded-4 border shadow-sm p-3">
              <div class="d-flex align-items-start justify-content-between gap-3">
                <div class="d-flex flex-column justify-content-start pt-1 ps-2">
                  <span class="entity-metric-label secondary-color text-uppercase fw-bold d-block mb-2">
                    Total Templates
                  </span>
                  <div class="entity-metric-value secondary-color fw-bold lh-1 mb-0 mt-1">{{ metrics.total_templates }}</div>
                </div>

                <div class="entity-metric-icon rounded-3 d-inline-flex align-items-center justify-content-center mt-2 me-1 text-white">
                  <i class="bi bi-files"></i>
                </div>
              </div>
            </article>
          </div>

          <div class="col-12 col-md-6 mt-2">
            <article class="entity-metric-card h-100 rounded-4 border shadow-sm p-3">
              <div class="d-flex align-items-start justify-content-between gap-3">
                <div class="d-flex flex-column justify-content-start pt-1 ps-2">
                  <span class="entity-metric-label secondary-color text-uppercase fw-bold d-block mb-2">
                    Active Assignments
                  </span>
                  <div class="entity-metric-value secondary-color fw-bold lh-1 mb-0 mt-1">{{ metrics.active_assignments }}</div>
                </div>

                <div class="entity-metric-icon rounded-3 d-inline-flex align-items-center justify-content-center mt-2 me-1 text-white">
                  <i class="bi bi-check2-square"></i>
                </div>
              </div>
            </article>
          </div>
        </section>
      </div>
    </section>

    <div class="d-md-none">
      <div class="input-group">
        <span class="input-group-text bg-light border-0 rounded-start-pill">
          <i class="bi bi-search text-secondary"></i>
        </span>
        <input
          v-model.trim="search_query"
          type="text"
          class="form-control form-control-sm bg-light border-0 rounded-end-pill"
          placeholder="Search templates..."
        />
      </div>
    </div>

    <section class="entity-inventory-panel rounded-4 border shadow-sm p-2">
      <div class="row g-2 align-items-start align-items-lg-center mb-3">
        <div class="col-12 col-lg">
          <div class="d-flex align-items-center gap-3">
            <div class="entity-section-icon rounded-3 d-inline-flex align-items-center justify-content-center">
              <i class="bi bi-grid-3x3-gap-fill"></i>
            </div>
            <div class="entity-section-title fw-bold fs-6">Active Templates</div>
          </div>
        </div>

        <div class="col-12 col-lg-auto">
          <div class="d-grid d-sm-flex align-items-stretch gap-2">
            <div class="input-group d-none d-md-flex">
              <span class="input-group-text bg-light border-0 rounded-start-pill">
                <i class="bi bi-search text-secondary"></i>
              </span>
              <input
                v-model.trim="search_query"
                type="text"
                class="form-control form-control-sm bg-light border-0 rounded-end-pill text-x"
                placeholder="Search templates..."
              />
            </div>
            <button type="button" class="btn btn-light btn-sm rounded-3" aria-label="Filter">
              <i class="bi bi-funnel"></i>
            </button>
            <button type="button" class="btn btn-light btn-sm rounded-3" aria-label="Sort">
              <i class="bi bi-sliders"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="entity-table-head secondary-color d-none d-lg-block rounded-3 mb-2 px-3 py-2 text-uppercase tracking-wide">
        <div class="row g-2 align-items-center">
          <div class="col-lg-4">Template Name</div>
          <div class="col-lg-2">Type</div>
          <div class="col-lg-2">Date Uploaded</div>
          <div class="col-lg-4"></div>
        </div>
      </div>

      <div v-if="loading" class="d-flex align-items-center gap-2 text-secondary text-xs py-2">
        <div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
        <span>Loading templates...</span>
      </div>

      <div v-else-if="paginated_templates.length" class="d-flex flex-column gap-2">
        <article
          v-for="tpl in paginated_templates"
          :key="tpl.id"
          class="entity-row-card bg-white rounded-4 border shadow-sm p-3"
        >
          <div class="entity-row-layout row g-2 align-items-center">
            <div class="entity-name-block col-12 col-lg-4 d-flex align-items-start align-items-sm-center gap-3">
              <div class="entity-type-icon entity-icon-surface rounded-3 d-inline-flex align-items-center justify-content-center">
                <i :class="[
                  'fs-5',
                  tpl.type === 'Contract' ? 'bi bi-file-earmark-text text-primary' : 'bi bi-file-earmark-plus text-secondary'
                ]"></i>
              </div>
              <div>
                <div class="entity-name fw-bold">{{ tpl.name }}</div>
                <div class="entity-updated text-secondary small">{{ tpl.description || 'Template ready for preview and assignment.' }}</div>
              </div>
            </div>

            <div class="col-12 col-sm-4 col-lg-2">
              <span class="text-xs fw-semibold text-secondary">{{ tpl.type }}</span>
            </div>

            <div class="col-12 col-sm-4 col-lg-2 text-xs text-secondary">
              {{ tpl.date_uploaded }}
            </div>

            <div class="col-12 col-lg-4 d-flex justify-content-start justify-content-lg-end align-items-center gap-2">
              <button
                type="button"
                class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1"
                @click="go_to_template_setup(tpl)"
              >
                Template Setup
              </button>
              <button
                type="button"
                class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1"
                @click="preview_template(tpl)"
                data-bs-toggle="modal"
                data-bs-target="#preview_template_modal"
              >
                Preview
              </button>
            </div>
          </div>
        </article>
      </div>

      <div v-else class="bg-white rounded-4 border shadow-sm p-5 text-center">
        <div class="entity-type-icon entity-icon-surface rounded-4 d-inline-flex align-items-center justify-content-center mb-3">
          <i class="bi bi-files fs-3"></i>
        </div>
        <div class="fw-bold mb-1">No Templates Found</div>
        <div class="text-secondary small">Templates will appear here once they are uploaded.</div>
      </div>

      <div v-if="!loading && paginated_templates.length" class="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-2 px-2 py-3">
        <div class="text-secondary text-xs">
          Showing {{ pagination_label }}
        </div>

        <nav aria-label="Templates pagination">
          <div class="d-inline-flex align-items-center rounded-3 border overflow-hidden bg-white">
            <button
              type="button"
              class="btn btn-sm btn-light border-0 rounded-0 px-2"
              @click="set_page(current_page - 1)"
              :disabled="current_page === 1"
              aria-label="Previous page"
            >
              <i class="bi bi-chevron-left"></i>
            </button>

            <button
              v-for="page in total_pages"
              :key="page"
              type="button"
              class="btn btn-sm rounded-0 border-0 border-start px-3 pagination-seg-btn"
              :class="page === current_page ? 'btn-primary-dark text-white' : 'btn-light'"
              @click="set_page(page)"
            >
              {{ page }}
            </button>

            <button
              type="button"
              class="btn btn-sm btn-light border-0 border-start rounded-0 px-2"
              @click="set_page(current_page + 1)"
              :disabled="current_page === total_pages"
              aria-label="Next page"
            >
              <i class="bi bi-chevron-right"></i>
            </button>
          </div>
        </nav>
      </div>
    </section>
  </div>
</div>

<teleport to="body">
  <div
    class="modal fade"
    id="preview_template_modal"
    tabindex="-1"
    aria-labelledby="preview_template_modal_label"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content bg-white rounded-4 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <p class="modal-title text-white text-xs mb-0" id="preview_template_modal_label">
            Template Preview
          </p>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body p-0">
          <div v-if="selected_template" class="d-flex flex-column">
            <div class="p-0 template-preview-container">
              <iframe
                v-if="selected_template.preview_url"
                :key="selected_template.preview_url"
                :src="selected_template.preview_url"
                class="template-preview-iframe"
                frameborder="0"
              ></iframe>
              <div v-else class="p-4 text-center text-secondary text-xs">
                No preview URL available for this template.
              </div>
            </div>
          </div>
          <div v-else class="p-4 text-center text-secondary text-xs">No template selected.</div>
        </div>
      </div>
    </div>
  </div>
</teleport>
